import React, { useState, useEffect, useContext } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { history } from '../../../helpers';
import { profile_url } from '../../../helpers/url_helper';
import { Navbar, Container, Nav, NavDropdown, Offcanvas, Image } from 'react-bootstrap';
import { userActions, dashboard_userActions, work_spaceActions, content_groupActions } from '../../../actions';
import { UserAvatar } from '../../../components';
import NotificationsDropdown from '../NotificationPage/dropdown';
import UserProfileForm from '../UserProfile/userProfileForm';
import logoWhite from '../../../images/logo/UPP-Logotype-Landscape-White-Transparent.png';
import OrganizationDropdown from './organization_dropdown';
import { UpgradeButton } from '../../../components';
import { TopbarContext } from "../../../contexts/TopbarContext";
import { CONTENT_GROUP_ACTION, mediaQueryConstants, userConstants } from '../../../constants';
import { useMediaQuery } from 'react-responsive';
import TimestampButton from 'components/stopwatch/components/TimestampButton';

function HeaderSection(props) {
  const dispatch = useDispatch();
  const {
          setSidebar,
          setWorkspaceContentGroupPopUp,
          current_organization,
          currentWorkSpace,
          can_create_organization,
          can_view_recycle_bin
        } = props
  const isLargeScreen = useMediaQuery({ query: `(max-width: ${mediaQueryConstants.LARGE}px)` });
  const notificationCount = useSelector(state => state.dashboard.notificationCount);
  const unread_notificationCount = useSelector(state => state.notification.unread_notificationCount);
  const currentUser = useSelector(state => state.dashboard.currentUser);
  const [ contentGroupPopUp, setContentGroupPopUp] = useState({id: null, show: false });
  const [highlighted_comment, setHighlightedComment] = useState({id: null, internal: false, cg_id: null});
  const [ workspaceId, setWorkspaceId] = useState();
  const [ workspace_update, set_workspace_update] = useState();
  const [ access_content, set_access_content] = useState();
  const [ access_content_edit, set_access_content_edit] = useState();
  const user_json = localStorage.getItem("user")

  function logout(response) {
    dispatch(userActions.logout());
  }

  const {
    setActiveOffCanvas,
    showNotificationsDropdown,
    setShowNotificationsDropdown,
  } = useContext(TopbarContext);

  useEffect(() => {  
    if(user_json){
      const onSuccess = (response) => {
        const { tracked_card } = response.data;
        dispatch({type: userConstants.TRACKED_CARD_ADD, payload: tracked_card });
      }

      const onFailure = (response) => {
        dispatch({ type: userConstants.TRACKED_CARD_REMOVE  })
      }

      const onError = (response) => {
        dispatch({ type: userConstants.TRACKED_CARD_REMOVE })
      }

      const onBefore = () => {
        dispatch({ type: userConstants.TRACKED_CARD_REMOVE  })
      }


      dispatch(dashboard_userActions.CommonInitialData({
        onSuccess,
        onFailure,
        onError,
        onBefore
      }))
    }

    return () =>{
      dispatch({ type: userConstants.TRACKED_CARD_REMOVE  })
    }

  }, [user_json]);

  const isUserLoggedIn = localStorage.getItem('user') ? true : false;
  // const email = localStorage.getItem('email');
  // const fname = localStorage.getItem('fname');
  // const profile_img = localStorage.getItem('profile_img');
  const isUserRole = localStorage.getItem('user_role')

  const openOffcanvas = () => {
    setActiveOffCanvas(prev => !prev)
  }

  const offcanvasDesktop = () => {
    document.body.classList.toggle('desktop_active');
    //setSidebar();
  }

  const [popupNewForm, setPopUpNewForm] = useState({
    show: false
  });;

  const handleCloseUserProfileForm = () => {
    setPopUpNewForm({show: false});
  }

  const handleShowNewForm = () => setPopUpNewForm({show: true});

  const handleShowProfile = () => {
    if (currentUser && currentUser.id) {
      history.push(`${profile_url(currentUser.id)}/activities`);
    }
  }

  document.onkeydown = function (evt) {
    if (evt.keyCode == 27) {
      if (!contentGroupPopUp.show) {
        setShowNotificationsDropdown(false)
      }
    }
  };

  const handleModalCloseNotification = (content_id, workspace_id, comment_id, comment_internal, cg_id, work_space_update, can_access_content, can_access_edit_title) => {
    dispatch({ type: CONTENT_GROUP_ACTION.CLOSE_CARD_MODAL });
    setTimeout(() => {
      dispatch({ type: CONTENT_GROUP_ACTION.SET_HIGHLIGHTED_COMMENT, payload: { id: comment_id, internal: comment_internal, cg_id: cg_id } });
      dispatch({ type: CONTENT_GROUP_ACTION.OPEN_CARD_MODAL, payload: { id: content_id, workspace_id: workspace_id } });
      
    } , 500);
  }

  const handleInlineEdit = (handleOnBlur, values, content_group_id) => {
    dispatch(content_groupActions.inlineEditContentGroup(handleOnBlur, values, content_group_id, workspaceId, true));

  }

  return (
    <div>
      <div className="layout__top-bar">
        {
          isUserLoggedIn
            ?
            <div className="header_iner ">
              <div
                className="container-fluid d-flex justify-content-between align-items-center"
                style={{paddingBottom: 0, paddingTop: 0}}
              >
                <Nav className="header__workspace-dropdown justify-content-end align-items-center">
                  <div>
                    <div className="sidebar_icon d-lg-none" onClick={openOffcanvas}>
                      <i className="fa fa-bars"></i>
                    </div>
                    <a href="/" className="logo__text mobile-none">
                      <img src={ logoWhite } title="Upprovall" alt="Upprovall" height="20" />
                    </a>
                  </div>

                  <OrganizationDropdown  hidden={isLargeScreen} />

                  {
                    isUserRole === "admin" && current_organization &&
                    <>
                      <Nav.Link href={`/organizations/${current_organization.id}/admin/board-stages`} className="px-1 mobile-none">
                        Board Stages
                      </Nav.Link>
                      <Nav.Link href={`/organizations/${current_organization.id}/admin/users`} className="px-1 mobile-none">
                        Users
                      </Nav.Link>
                    </>
                  }

                  {
                    current_organization && can_view_recycle_bin && 
                    <Nav.Link href={`/organizations/${current_organization.id}/recycle_bin`} className="px-1 mobile-none">
                        Recycle Bin
                    </Nav.Link>
                  }
                </Nav>


                <Nav className="header__user-dropdown ml-auto justify-content-end align-items-center">
                  {
                    currentWorkSpace && !can_create_organization && current_organization?.personal && !isLargeScreen &&
                    <UpgradeButton
                      upgrade_button_style="small"
                    />
                  }

                  <TimestampButton />
                  {
                    !isLargeScreen &&
                      <>
                        
                        <Nav.Link onClick={() => setShowNotificationsDropdown(!showNotificationsDropdown)} className={"notification-link mr-4 d-flex align-items-center" + (showNotificationsDropdown ? " active" : "")} style={{position: 'relative'}} >
                          <i className="fa fa-bell">
                          </i>
                          {(unread_notificationCount && unread_notificationCount !== 0) ? <span className="unread_badge" /  > : null}
                        </Nav.Link>
                      </>
                    }

                    <div className={`${showNotificationsDropdown ? '' : 'd-none'}`}>
                      <div className="notification-backdrop" onClick={() => setShowNotificationsDropdown(!showNotificationsDropdown)}/>
                      <NotificationsDropdown
                        handleHideNotificationsDropdown={() => setShowNotificationsDropdown(false)}
                        handleModalCloseNotification={handleModalCloseNotification}
                        showNotificationsDropdown={showNotificationsDropdown}
                      />
                    </div>


                  <NavDropdown
                    title={
                      <div className="user-name">
                        { currentUser &&
                          <UserAvatar icon={ currentUser.logo && currentUser.logo.url } name={ currentUser.name } name_initials={ currentUser.name_initials } size="35" />
                        }
                      </div>
                    }
                    id="basic-nav-dropdozwn"
                    onClick={() => setShowNotificationsDropdown(false)}
                    className='user-profile-dropdown'
                  >
                    <NavDropdown.Item href="#" className={"d-lg-none"}>
                      {currentUser && currentUser.first_name ? currentUser && currentUser.first_name : currentUser && currentUser.email }
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={handleShowProfile}>
                      Profile
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={handleShowNewForm}>
                      Settings
                    </NavDropdown.Item>
                    <NavDropdown.Item href="#" onClick={logout}>
                      Log Out
                    </NavDropdown.Item>
                  </NavDropdown>
                </Nav>
              </div>
            </div>
          :null
        }

        <UserProfileForm handleCloseUserProfileForm = {handleCloseUserProfileForm} showForm={popupNewForm.show}/>
      </div>

    </div>
  );
}


const mapStateToProps = (state) => {
  return {
    current_organization: state.organization.current_organization,
    currentWorkSpace: state.work_space.currentWorkSpace,
    can_create_organization: state.organization.can_create_organization,
    can_view_recycle_bin: state.organization.can_view_recycle_bin,
  };
};

export default connect(mapStateToProps, { dashboard_userActions })(HeaderSection);
